import { WishlistButton as WishlistButtonBase } from "@omni/components/components/Navigation/Buttons/WishlistButton/wishlistButton";
import { WishlistButtonProps } from "@omni/types/components/props/wishlistButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { WishlistButtonComponent } from "@/components/Navigation/Buttons/WishlistButton/wishlistButton.component";

export const WishlistButton = ({
    icon,
    hover,
    invert,
    invertMobile,
    link,
    ariaLabel,
    text,
    textHidden
}: WishlistButtonProps<BaseStore.Etna>) => {
    return (
        <WishlistButtonBase
            icon={icon}
            hover={hover}
            invert={invert}
            invertMobile={invertMobile}
            link={link}
            ariaLabel={ariaLabel}
            text={text}
            textHidden={textHidden}
        >
            <WishlistButtonComponent />
        </WishlistButtonBase>
    );
};
